<div class="login-dialog-title-container">
  <button mat-button class="close-button" [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
  <h2 [translate]="title"></h2>
  <div *ngIf="displaySocialLogin$ | async">
    <gb-social-login-register [dialog]="true" [redirectHome]="false"></gb-social-login-register>
  </div>
</div>
<gb-login-form [redirectHome]="false" [dialog]="true"> </gb-login-form>
